/** Exact street-type options from extTipoVia (display/save by name). */
export const SPAIN_STREET_TYPE_OPTIONS: Array<{ code: string; name: string }> = [
  { code: "AD", name: "ACCESO" },
  { code: "AF", name: "ACEQUIA" },
  { code: "AH", name: "ALAMEDA" },
  { code: "AK", name: "ALBEREDA" },
  { code: "AR", name: "ALDEA" },
  { code: "AX", name: "ALTO" },
  { code: "AZ", name: "ANGOSTA" },
  { code: "BF", name: "ARROYO" },
  { code: "BH", name: "ATAJILLO" },
  { code: "BK", name: "ATAJO" },
  { code: "BZ", name: "AVENIDA" },
  { code: "CF", name: "BAJADA" },
  { code: "CK", name: "BARRACAS" },
  { code: "CT", name: "BARRIADA" },
  { code: "CV", name: "BARRIO" },
  { code: "DR", name: "BLOQUE" },
  { code: "DV", name: "CALA" },
  { code: "ED", name: "CALLE" },
  { code: "EF", name: "CALLEJA" },
  { code: "EH", name: "CALLEJON" },
  { code: "EK", name: "CALLEJUELA" },
  { code: "EP", name: "CALZADA" },
  { code: "EV", name: "CAMINO" },
  { code: "FF", name: "CARRERA" },
  { code: "FK", name: "CARRETERA" },
  { code: "FR", name: "CARRIL" },
  { code: "FT", name: "CASA" },
  { code: "FV", name: "CASERIO" },
  { code: "GB", name: "COBERTIZO" },
  { code: "GD", name: "COLONIA" },
  { code: "GH", name: "CORRALILLO" },
  { code: "GK", name: "CORREDOR" },
  { code: "GM", name: "CORTIJO" },
  { code: "GR", name: "COSO" },
  { code: "GT", name: "COSTA" },
  { code: "GV", name: "COSTANILLA" },
  { code: "GX", name: "CRUCE" },
  { code: "HD", name: "CUESTA" },
  { code: "HH", name: "DEHESA" },
  { code: "ZZ", name: "DESCONOCIDO" },
  { code: "HJ", name: "DISEMINADO" },
  { code: "HR", name: "EDIFICIO" },
  { code: "HZ", name: "ENSENADA" },
  { code: "JM", name: "ESCALA" },
  { code: "JS", name: "ESCALERA" },
  { code: "JT", name: "ESCALINATA" },
  { code: "KT", name: "FINCA" },
  { code: "GA", name: "GALERIA" },
  { code: "LH", name: "GLORIETA" },
  { code: "LK", name: "GRAN VIA" },
  { code: "LP", name: "GRUPO" },
  { code: "NZ", name: "LUGAR" },
  { code: "PD", name: "MANZANA" },
  { code: "PX", name: "MONTE" },
  { code: "QD", name: "PARAJE" },
  { code: "QE", name: "PARQUE" },
  { code: "QG", name: "PARTIDA" },
  { code: "QK", name: "PASADIZO" },
  { code: "QM", name: "PASAJE" },
  { code: "QR", name: "PASARELA" },
  { code: "QX", name: "PASEO" },
  { code: "QZ", name: "PASILLO" },
  { code: "RB", name: "PASO" },
  { code: "RZ", name: "PLAYA" },
  { code: "SB", name: "PLAZA" },
  { code: "SF", name: "PLAZOLETA" },
  { code: "SH", name: "PLAZUELA" },
  { code: "SK", name: "POBLADO" },
  { code: "PG", name: "POLIGONO" },
  { code: "TB", name: "PONTON" },
  { code: "TF", name: "PORTICO" },
  { code: "TM", name: "POSTIGO" },
  { code: "TX", name: "PUENTE" },
  { code: "TZ", name: "PUERTO" },
  { code: "UM", name: "RAMBLA" },
  { code: "UT", name: "REGATO" },
  { code: "UZ", name: "RIERA" },
  { code: "VD", name: "RINCONADA" },
  { code: "VF", name: "RONDA" },
  { code: "SD", name: "SENDA" },
  { code: "VV", name: "SENDERO" },
  { code: "VX", name: "SEQUIA" },
  { code: "WH", name: "SOLANA" },
  { code: "WK", name: "SUBIDA" },
  { code: "WT", name: "TORRENTE" },
  { code: "WX", name: "TRAVESIA" },
  { code: "XD", name: "TUNEL" },
  { code: "XR", name: "URBANIZACION" },
  { code: "YB", name: "VALLE" },
  { code: "YC", name: "VECINDARIO" },
  { code: "YD", name: "VEREDA" },
  { code: "YF", name: "VIA" },
  { code: "2", name: "VIA ALTERNATIVA" },
  { code: "1", name: "VIA DIRECTA" },
  { code: "YH", name: "VIAL" },
  { code: "YV", name: "ZOKO" },
  { code: "YZ", name: "ZONA" },
  { code: "ZD", name: "ZULO" },
];

